import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

const styles = {
  imageContainer: {
    position: 'relative',
    borderRadius: 4,
    overflow: 'hidden',
    cursor: 'pointer',
    '&:hover': {
      '& $children': {
        filter: 'contrast(10%)',
      },
      '& $imageChange': {
        opacity: 1,
      },
    },
  },

  imageChange: {
    position: 'absolute',
    top: '50%',
    left: '20%',
    transform: 'translateY(-50%)',
    maxWidth: '60%',
    color: 'common.white',
    opacity: 0,
    transition: 'opacity 250ms ease-in-out',
    textAlign: 'center',
  },

  cameraIcon: {
    marginBottom: 1,
  },

  children: {
    transition: 'all 250ms ease-in-out',
  },
} as const;

interface Props {
  onToggle: () => void;
}

const ImageChange: FC<Props> = ({ children, onToggle }) => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.imageContainer} onClick={onToggle}>
      <Box sx={styles.children}>{children}</Box>
      <Box sx={styles.imageChange}>
        <AddPhotoAlternateIcon fontSize="large" />
        <Typography color="inherit" variant="caption">
          {t('groups:imageChange')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ImageChange;
